import { styled } from '@mui/system';
import { Box, Button, Card, TextField, Typography } from '@mui/material';

export const FolderTitle = styled(Typography)({
  fontSize: "20px",
  fontWeight: "bold",
  marginBottom: "16px",
  color: "#333"
})

export const FolderButton = styled(Button)({
  backgroundColor: "#4caf50",
  color: "white",
  "&:hover": {
    backgroundColor: "#388e3c"
  }
})

export const ServiceModuleWrapper = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "16px"
})

export const FolderServiceModuleStyled = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(2),
  borderRadius: '8px',
  marginBottom: theme.spacing(2),
  '& .MuiTypography-h5': {
    color: theme.palette.primary.main,
  },
  '& .MuiButton-contained': {
    marginTop: theme.spacing(2),
  }
}));

export const FolderContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4),
  backgroundColor: theme.palette.background.default,
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)"
}));

export const ItemGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
  gap: theme.spacing(2),
}));

export const AddButton = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  marginBottom: theme.spacing(2),
}));

export const CreatorContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(2),
  alignItems: 'center',
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
  padding: theme.spacing(2),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.paper,
  position: 'relative',
}));

export const TypeSelectContainer = styled(Box)(({ theme }) => ({
  flex: 1,
  minWidth: 200,
}));

export const CreateButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  justifyContent: 'flex-end',
}));

export const ErrorMessage = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  marginTop: theme.spacing(1),
  fontSize: '0.875rem',
}));

/** --- Edit Modal (EditServiceModuleModal.tsx) --- */
export const EditCardContainer = styled(Box)(({ theme }) => ({
  border: '2px dashed #ccc',
  padding: theme.spacing(2),
  borderRadius: '12px',
  background: '#fafafa',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const FormRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

export const FormRowHalf = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1.5),
  flexWrap: 'nowrap',
  alignItems: 'center',
}));

export const FormRowSwitches = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(3),
  flexWrap: 'nowrap',
  alignItems: 'center',
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
  flex: 1,
  minWidth: 200,
}));

export const ActionButtons = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1.5),
  justifyContent: 'flex-end',
}));

export const StyledDialogContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.default,
  borderRadius: theme.shape.borderRadius,
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  overflow: 'hidden',
}));

export const StyledFolderContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4),
  backgroundColor: theme.palette.background.default,
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)"
}));

export const StyledCard = styled(Card)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: '10px',
  height: '130px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  cursor: 'pointer',
  padding: theme.spacing(2),
  overflow: 'hidden',
  color: '#fff',
  '& .MuiSvgIcon-root': {
    color: '#fff',
  },
}));

export const CardHeaderContent = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const CardIconArea = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

export const ModuleItemBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(1.5, 2),
  cursor: 'pointer',
  backgroundColor: theme.palette.background.paper,
  '&:hover': {
      backgroundColor: theme.palette.action.hover,
  }
}));

export const DividerLine = styled(Box)(({ theme }) => ({
  height: '1px',
  backgroundColor: theme.palette.primary.main,
  marginLeft: theme.spacing(2),
}));

export const FileUploaderContainer = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.grey[300]}`,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
}));